import type { SVGProps } from 'react';
const DawnFlagCAS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CAS_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-CAS_svg__a)">
      <path fill="#19BFBF" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M4.335 6.638a.333.333 0 0 0 .148.444l1.51.769c.162.083.228.28.148.444l-.23.468a.333.333 0 0 1-.45.15l-.676-.343a.33.33 0 0 0-.151-.037H3.476a.333.333 0 0 0-.333.334v.494c0 .143.09.27.226.316l.842.286a.333.333 0 0 1 .131.549l-.056.057a.33.33 0 0 0-.096.234v.344q0 .053.017.104l.464 1.418a.33.33 0 0 0 .166.193l.707.36c.13.066.287.04.389-.063l.876-.892.205-.21a.333.333 0 0 0-.086-.53l-.49-.249a.28.28 0 0 1 .197-.522l1.495.38c.147.038.25.17.25.323v.708c0 .065.02.129.055.183l.895 1.366c.061.094.166.15.278.15h.117c.137 0 .26-.083.31-.21l.688-1.753a.333.333 0 0 1 .61-.025l.167.34a.3.3 0 0 0 .061.087l.972.99a.3.3 0 0 0 .087.063l.514.262a.333.333 0 0 0 .485-.297v-.387a.33.33 0 0 0-.096-.233l-.199-.203a.333.333 0 0 1 0-.467l.197-.2a.33.33 0 0 1 .238-.1h.827a.33.33 0 0 0 .152-.036l.794-.404a.33.33 0 0 0 .182-.297v-.726a.33.33 0 0 0-.096-.234l-.198-.202a.333.333 0 0 1 0-.468l.488-.497a.333.333 0 0 1 .537.087l.252.513a.235.235 0 1 0 .422-.208l-.212-.433a.333.333 0 0 1 .147-.444l.462-.235a.333.333 0 0 0 .148-.444l-.318-.647a.33.33 0 0 0-.192-.17l-.937-.317a.333.333 0 0 1-.131-.55l.578-.588a.33.33 0 0 1 .237-.1h1.224a.33.33 0 0 0 .3-.186l.219-.446a.333.333 0 0 0-.269-.479l-4.657-.431a.297.297 0 0 1-.184-.504.3.3 0 0 0 .085-.209v-.611a.333.333 0 0 0-.334-.334H11.14a.33.33 0 0 0-.238.1L9.494 3.667a.33.33 0 0 1-.156.09l-2.005.51-1.974.502a.33.33 0 0 1-.233-.026l-.217-.11a.333.333 0 0 0-.468.4l.23.705a.33.33 0 0 1-.017.25zm7.189 6.695a.53.53 0 0 1-.524.534.53.53 0 0 1-.524-.534c0-.294.234-.533.524-.533.289 0 .524.239.524.533m-3.667-4.8c.29 0 .524-.238.524-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.533.524.533m9.952 1.6v.534l-.49.5a.333.333 0 0 0 .237.566h.046a.33.33 0 0 0 .299-.186l.432-.88zm0 0 .295-.15c.19-.096.121-.383-.092-.383a.203.203 0 0 0-.203.203z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCAS;
